import { Injectable } from '@angular/core';
import { ServiceModule } from '../../../service.module';

@Injectable({ providedIn: ServiceModule })
export class LocalStorageService {
    getLocalStorage(): Storage {
        return localStorage;
    }

    set(key: string, data: string): void {
        this.getLocalStorage().setItem(key, data);
    }

    get(key: string): string | null {
        return this.getLocalStorage().getItem(key);
    }

    remove(key: string): void {
        this.getLocalStorage().removeItem(key);
    }
}
